export const DATA = {
    orderStatus: [
        { value: 1, name: 'Đơn hàng hủy', color: 'black', orderIndex: 1 },
        { value: 5, name: 'Đã mua hàng', color: '#2bbae4', orderIndex: 4 },
        { value: 14, name: 'Chờ xuất kho TQ', color: '#6b0a00', orderIndex: 7 },
        { value: 8, name: 'Chờ thanh toán', color: '#afa22e', orderIndex: 10 },
        { value: 0, name: 'Chờ đặt cọc', color: 'red', orderIndex: 2 },
        { value: 16, name: 'Shop đã phát hàng', color: '#f7819f', orderIndex: 5 },
        { value: 15, name: 'Đã xuất kho TQ', color: '#a65600', orderIndex: 8 },
        { value: 9, name: 'Đã thanh toán', color: 'blue', orderIndex: 11 },
        { value: 2, name: 'Đã đặt cọc', color: 'green', orderIndex: 3 },
        { value: 12, name: 'Đã nhập kho TQ', color: '#9c1839', orderIndex: 6 },
        { value: 7, name: 'Đã nhập kho VN', color: 'orange', orderIndex: 9 },
        { value: 13, name: 'Khiếu nại', title: 'Đã khiếu nại', color: '#9732f3', orderIndex: 12 },
        { value: 10, name: 'Hoàn thành', color: '#7a8498', orderIndex: 13 },
    ],
    depositStatus: [
        { value: 1, name: 'Đơn hàng hủy', color: 'black', orderIndex: 1 },
        { value: 16, name: 'Đang vận chuyển', color: '#f7819f', orderIndex: 2 },
        { value: 8, name: 'Chờ thanh toán', color: '#afa22e', orderIndex: 3 },
        { value: 7, name: 'Đã nhập kho', color: 'orange', orderIndex: 4 },
        { value: 9, name: 'Đã thanh toán', color: 'blue', orderIndex: 5 },
        { value: 10, name: 'Hoàn thành', color: '#7a8498', orderIndex: 6 },
    ],
    paymentTypeList: [
        { value: 1, name: 'Trực tiếp', color: '#808080', textColor: '#000' },
        { value: 2, name: 'Ví', color: '#0059b3', textColor: '#FFF' },
    ],
    paymentStatusList: [
        { value: 2, name: 'Đặt cọc', color: '#808080', textColor: '#000' },
        { value: 12, name: 'Nhận lại cọc', color: '#e63900', textColor: '#000' },
        { value: 9, name: 'Thanh toán', color: '#0059b3', textColor: '#FFF' },
        { value: 10, name: 'Thanh toán ship', color: '#7a8498', textColor: '#FFF' },
    ],
    complainStatusList: [
        { value: 0, name: 'Đã hủy', color: 'black' },
        { value: 1, name: 'Chờ xử lý', color: 'red' },
        { value: 2, name: 'Đang xử lý', color: 'orange' },
        { value: 3, name: 'Đã xử lý', color: 'blue' },
    ],
    statusAction: [
        { text: 'Hủy đơn hàng', color: '#d9534f', orderStatus: [0, 2] },
        { text: 'Khiếu nại', color: '#9732f3', orderStatus: [9, 13] },
    ],
    statusRecharge: [
        { value: 1, name: 'Chờ duyệt', color: '#808080', textColor: '#000' },
        { value: 2, name: 'Đã duyệt', color: '#0059b3', textColor: '#FFF' },
        { value: 3, name: 'Hủy lệnh', color: '#e63900', textColor: '#000' },
        { value: 4, name: 'Chuyển khoản', color: '#00b300', textColor: '#FFF' },
        { value: 5, name: 'Tiền mặt', color: '#2d8659', textColor: '#FFF' },
    ],
    statusWithdrawal: [
        { value: 1, name: 'Chờ duyệt', color: '#808080', textColor: '#000' },
        { value: 2, name: 'Đã duyệt', color: '#0059b3', textColor: '#FFF' },
        { value: 3, name: 'Hủy lệnh', color: '#e63900', textColor: '#000' }
    ],
    walletTradeType: [
        { value: 1, name: 'Đặt cọc' },
        { value: 2, name: 'Nhận lại tiền đặt cọc' },
        { value: 3, name: 'Thanh toán hóa đơn' },
        { value: 4, name: 'Nạp tiền' },
        { value: 5, name: 'Rút tiền' },
        { value: 6, name: 'Hủy lệnh rút tiền' },
        { value: 7, name: 'Xử lý khiếu nại' }
    ],
    billOfLadingStatus: [
        { value: 1, name: 'Shop đã phát hàng', disabled: false, color: '#f7819f', textColor: '#FFF' },
        { value: 2, name: 'Đã ký nhận', disabled: false, color: '#9c1839', textColor: '#FFF' },
        { value: 5, name: 'Đã đóng bao', disabled: false, color: '#6b0a00', textColor: '#FFF' },
        { value: 6, name: 'Đã xuất kho TQ', disabled: false, color: '#a65600', textColor: '#FFF' },
        { value: 3, name: 'Hàng đã về kho VN', disabled: false, color: 'green', textColor: '#FFF' },
        { value: 4, name: 'Đã giao hàng', disabled: false, color: 'blue', textColor: '#FFF' }
    ],
    storeAreas: [
        { value: 1, name: 'Kho Hà Nội' },
        // { value: 2, name: 'Kho Thái Nguyên' },
        // { value: 3, name: 'Kho TP.Hồ Chí Minh' }
    ],
    reasonWithdraw: [
        { value: 1, name: 'Hệ thống khó sử dụng' },
        { value: 2, name: 'Chất lượng phục vụ không tốt' },
        { value: 3, name: 'Hàng về chậm' },
        { value: 4, name: 'Chi phí cao' },
        { value: 5, name: 'Lý do khác' }
    ],
    requestPaymentStatus: [
        { value: 1, name: 'Chờ xử lý', color: '#d9534f', textColor: '#000' },
        { value: 2, name: 'Chờ xuất hàng', color: 'green', textColor: '#FFF' },
        { value: 3, name: 'Đã xuất hàng', color: 'blue', textColor: '#FFF' }
    ],
    shippingMethods: [
        { value: 1, name: 'Viettel', max_weight: 1000 }, 
        { value: 2, name: 'GHTK', max_weight: 20 },
        { value: 3, name: 'Ninja', max_weight: 20, invisible: true },
        { value: 4, name: 'Ship nội thành (Hà Nội)', max_weight: 10000 },
        { value: 5, name: 'J&T', max_weight: 20, invisible: true },
        { value: 6, name: 'Phương thức khác (Liên hệ CSKH)', max_weight: 10000 }        
    ]
};
